<div class="h-full flex flex-col">
	<!-- Header -->
	<div class="flex items-center justify-between p-4 border-b bg-white">
		<div class="flex items-center gap-4">
			<ui-button
				preset="EXTRA_LOW_EMPHASIS"
				icon="arrow-back"
				label="Back"
				(click)="goBack()"
			/>

			<span class="h2">Review Intake Responses</span>

			<app-intake-status-display />
		</div>

		<div class="flex gap-4 items-center">
			<span class="text-sm"
				>({{ getSelectedItemsCount() }}) responses selected</span
			>
			<ui-button
				preset="HIGH_EMPHASIS"
				icon="plus"
				label="Add responses to matter"
				[disabled]="getSelectedItemsCount() === 0"
				(click)="submitResponsesToMatter()"
			/>

			<ui-dropdown [items]="kebabItems">
				<ui-button
					dropdown-trigger
					preset="EXTRA_LOW_EMPHASIS"
					icon="dots-vertical"
				/>
			</ui-dropdown>
		</div>
	</div>

	<!-- Tabs -->
	<div class="flex-1 bg-gray-50">
		<ui-tabs queryParamKey="tab">
			<ui-tab id="all" title="All">
				<div post-title class="text-xs text-grey-light">{{ allCount_() }}</div>

				<app-intake-responses-table
					[sections]="allSections_()"
					[formOptions]="formOptions_()"
					[selectedFormId]="selectedFormId_()"
					[checkboxStates]="checkboxStates_()"
					[allItemsSelected]="areAllItemsSelected()"
					[showSelectAllCheckbox]="true"
					[showMatterDetailsColumn]="true"
					[showStatusColumn]="false"
					(formSelected)="onFormSelected($event)"
					(rowToggled)="onRowToggled($event)"
					(selectAllToggled)="onSelectAll($event)"
				></app-intake-responses-table>
			</ui-tab>

			<ui-tab id="ready-to-review" title="Ready to Review">
				<tabler-icon
					pre-title
					class="text-amber-600 h-4 w-4"
					name="progress-check"
				></tabler-icon>
				<div post-title class="text-xs text-grey-light">
					{{ readyToReviewCount_() }}
				</div>

				<app-intake-responses-table
					[sections]="readyToReviewSections_()"
					[formOptions]="formOptions_()"
					[selectedFormId]="selectedFormId_()"
					[checkboxStates]="checkboxStates_()"
					[allItemsSelected]="areAllItemsSelected()"
					[showSelectAllCheckbox]="true"
					[showMatterDetailsColumn]="true"
					[showStatusColumn]="false"
					(formSelected)="onFormSelected($event)"
					(rowToggled)="onRowToggled($event)"
					(selectAllToggled)="onSelectAll($event)"
				></app-intake-responses-table>
			</ui-tab>

			<ui-tab id="missing-responses" title="Missing Responses">
				<tabler-icon
					pre-title
					class="text-gray-500 h-4 w-4"
					name="progress-check"
				></tabler-icon>
				<div post-title class="text-xs text-grey-light">
					{{ missingResponsesCount_() }}
				</div>

				<app-intake-responses-table
					[sections]="missingResponsesSections_()"
					[formOptions]="formOptions_()"
					[selectedFormId]="selectedFormId_()"
					[checkboxStates]="checkboxStates_()"
					[allItemsSelected]="areAllItemsSelected()"
					[showSelectAllCheckbox]="false"
					[showMatterDetailsColumn]="true"
					[showStatusColumn]="false"
					(formSelected)="onFormSelected($event)"
					(rowToggled)="onRowToggled($event)"
					(selectAllToggled)="onSelectAll($event)"
				></app-intake-responses-table>
			</ui-tab>

			<ui-tab id="added-to-matter" title="Complete">
				<tabler-icon
					pre-title
					class="text-green-600 h-4 w-4"
					name="circle-check"
				></tabler-icon>
				<div post-title class="text-xs text-grey-light">
					{{ addedToMatterCount_() }}
				</div>

				<app-intake-responses-table
					[sections]="addedToMatterSections_()"
					[formOptions]="formOptions_()"
					[selectedFormId]="selectedFormId_()"
					[checkboxStates]="checkboxStates_()"
					[allItemsSelected]="areAllItemsSelected()"
					[showSelectAllCheckbox]="false"
					[showMatterDetailsColumn]="true"
					[showStatusColumn]="false"
					(formSelected)="onFormSelected($event)"
					(rowToggled)="onRowToggled($event)"
					(selectAllToggled)="onSelectAll($event)"
				></app-intake-responses-table>
			</ui-tab>

			<!-- TODO placeholder tab, to be completed with custom questions implementation -->
			<ui-tab id="custom-questions" title="Custom Questions">
				<tabler-icon
					pre-title
					class="text-gray-500 h-4 w-4"
					name="north-star"
				></tabler-icon>
				<div post-title class="text-xs text-grey-light">
					{{ customQuestionsCount_() }}
				</div>

				<app-intake-responses-table
					[sections]="customQuestionsSections_()"
					[formOptions]="formOptions_()"
					[selectedFormId]="selectedFormId_()"
					[checkboxStates]="checkboxStates_()"
					[allItemsSelected]="areAllItemsSelected()"
					[showSelectAllCheckbox]="false"
					[showMatterDetailsColumn]="false"
					[showStatusColumn]="true"
					(formSelected)="onFormSelected($event)"
					(rowToggled)="onRowToggled($event)"
					(selectAllToggled)="onSelectAll($event)"
				></app-intake-responses-table>
			</ui-tab>
		</ui-tabs>
	</div>
</div>
